class Api {
  static host = process.env.GATSBY_URL_BACKEND_SEGUROS;

  static get(route, header) {
    return this.xhr(route, null, 'GET', header);
  }

  static put(route, params, header) {
    return this.xhr(route, params, 'PUT', header);
  }

  static post(route, params, header) {
    return this.xhr(route, params, 'POST', header);
  }

  static delete(route, params, header) {
    return this.xhr(route, params, 'DELETE', header);
  }

  /**
   * @param {Object.<string, string>} query
   * @return {string}
   */
  static encodeQuery(query) {
    const formattedQuery = Object.entries(query)
      .filter(([, value]) => value)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);

    return formattedQuery.join('&');
  }

  static async xhr(route, params, verb, header = {}) {
    const url = `${this.host}${route}`;

    const defaultHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    const options = {
      method: verb,
      headers: { ...defaultHeaders, ...header },
    };

    if (verb !== 'GET') {
      options.body = JSON.stringify(params);
    }

    const result = await fetch(url, options);

    if (result.ok) {
      const text = await result.text();
      try {
        return JSON.parse(text);
      } catch (err) {
        return text;
      }
    }

    if (result.status === 401) {
      window.location.href = '/not-access';
      return '';
    }

    if (result.status !== 500) {
      const { message, error } = await result.json();
      // eslint-disable-next-line no-console
      console.error(message, error);
      throw new Error(message || 'Ocorreu um erro inesperado.');
    }

    throw new Error('Ocorreu um erro inesperado.');
  }
}

export default Api;
